import React, { useEffect, useState } from 'react';
import { cameraService } from '../../../services/central-api/cameras';
import FilterDropdown from '../../../components/Filter/components/FilterDropdown';
import { translate } from '../../../services/translate';

interface Props {
    value: string;
    setValue: React.Dispatch<React.SetStateAction<string>>;
    zIndex: number;
    cameraText: string;
    setCameraText: React.Dispatch<React.SetStateAction<string>>;
}

function DownloadCameraDropdown({ value, setValue, zIndex, cameraText, setCameraText }: Props) {
    const [items, setItems] = useState<{ label: string; value: string; }[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [filterTimeout, setFilterTimeout] = useState<NodeJS.Timeout>();

    async function getItems(textFilter: string) {
        try {
            setIsLoading(true);
            const cameras = await cameraService.getSimplifiedDownloadCameras(textFilter);
            setItems(cameras.map((camera) => ({
                value: String(camera.id),
                label: camera.title
            })));
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (cameraText && cameraText.length > 2) {
            getItems(cameraText);
        }
    }, [cameraText]);

    return (
        <FilterDropdown
            label={translate('camera')}
            placeholder={translate('typeToSearch')}
            items={items}
            multiple={false}
            setValue={setValue}
            value={value}
            zIndex={zIndex}
            searchable={false}
            disableLocalSearch={true}
            loading={isLoading}
            onChangeSearchText={(text) => {
                if (text && text.length > 2) {
                    if (filterTimeout) {
                        clearTimeout(filterTimeout);
                    }
                    const timeout = setTimeout(() => {
                        setCameraText(text);
                    }, 1000);
                    setFilterTimeout(timeout);
                }
            }}
        />
    );
}

export default DownloadCameraDropdown;
